import { ACDSessionManager } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import type { ConferencePartyInfo } from '../types';
import { acdApiGet, extractArrayFromResponse } from './acd-api.util';

function mapConferenceParty(item: unknown, index: number): ConferencePartyInfo {
  const contact = item as {
    contactId?: string | number;
    ContactId?: string | number;
    ani?: string;
    ANI?: string;
    dnis?: string;
    DNIS?: string;
    fromAddress?: string;
    toAddress?: string;
    status?: string;
    Status?: string;
    type?: string;
    Type?: string;
    agentId?: string | number;
    AgentId?: string | number;
    customerName?: string;
    CustomerName?: string;
    label?: string;
    Label?: string;
    isInbound?: boolean;
  };

  const phoneNumber = contact.ani || contact.ANI || contact.fromAddress || contact.toAddress || '';
  const contactType = contact.type || contact.Type || '';
  const isAgent = contactType.toLowerCase().includes('agent');
  const isInbound = contact.isInbound === true;

  let partyType: 'agent' | 'customer' | 'external' = 'external';
  if (isAgent) {
    partyType = 'agent';
  } else if (isInbound || index === 0) {
    partyType = 'customer';
  }

  let name = contact.customerName || contact.CustomerName || contact.label || contact.Label || '';
  if (!name && phoneNumber) {
    name = phoneNumber;
  }
  if (!name) {
    name = partyType === 'agent' ? 'Agent' : partyType === 'customer' ? 'Customer' : 'External';
  }

  return {
    partyId: String(contact.contactId || contact.ContactId || index),
    partyType,
    name,
    phoneNumber: phoneNumber || undefined,
    agentId:
      contact.agentId || contact.AgentId ? String(contact.agentId || contact.AgentId) : undefined,
    status: contact.status || contact.Status || undefined,
    isOriginalCaller: index === 0 || isInbound,
  };
}

export async function getConferenceParties(): Promise<ConferencePartyInfo[]> {
  logger.debug('[CXone SDK] Getting conference parties...');

  const acdSession = ACDSessionManager.instance;
  const sessionId = acdSession.getSessionId();

  if (!sessionId) {
    logger.error('[CXone SDK] Missing session ID for getConferenceParties');
    return [];
  }

  try {
    const data = await acdApiGet(
      `/InContactAPI/services/v23.0/agent-sessions/${sessionId}/interactions`,
      'getConferenceParties'
    );

    if (!data) {
      return [];
    }

    const contacts = extractArrayFromResponse(data, [
      'interactions',
      'Interactions',
      'contacts',
      'Contacts',
    ]);
    const parties = contacts.map(mapConferenceParty);

    logger.debug('[CXone SDK] Mapped conference parties:', parties);
    return parties;
  } catch (error) {
    logger.error('[CXone SDK] getConferenceParties failed:', error);
    return [];
  }
}
